import { Types } from '@store/types';

const initialState = { priceRangeTableData: [], profitMarginTableData: [] };
const BrandProfileReducer = (state = initialState, action) => {
	switch (action.type) {
		case Types.FETCH_BRAND_PROFILE_BY_BRAND_ID:
			return { ...action.payload };
		case Types.FETCH_PRICE_RANGE_TABLE_DATA_BY_BRAND_ID:
			return {
				...state,
				priceRangeTableData: action.payload
			};
		case Types.FETCH_PROFIT_MARGIN_TABLE_DATA_BY_BRAND_ID:
			return {
				...state,
				profitMarginTableData: action.payload
			};

		default:
			return state;
	}
};

export default BrandProfileReducer;
